<style scoped>
.consent-row {
  padding: 10px;
  text-align: center;
  height: fit-content;
}

.container {
  position: relative;
  max-height: 200px;
  height: fit-content;
}

.center {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.fs-gal-view {
  height: 100vh;
  width: 100vw;
  margin: 0;
  padding: 0;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  text-align: center;
  background-size: contain;
  background-position: center center;
  background-color: rgba(20, 20, 20, 0.7);
  background-repeat: no-repeat;
  overflow: hidden;
}
.fs-gal-view h1 {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
  height: 50px;
  line-height: 50px;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  font-weight: 300;
  font-size: 26px;
}
.fs-gal-prev,
.fs-gal-next,
.fs-gal-close {
  position: absolute;
  top: calc(50vh - 40px);
  height: 40px;
  width: 40px;
}
.fs-gal-prev {
  left: 0;
}
.fs-gal-next {
  right: 0;
}
.fs-gal-close {
  top: 4px;
  right: 30px;
  height: 30px;
  width: 30px;
}
.fs-gal:hover,
.fs-gal-nav:hover,
.fs-gal-close:hover {
  cursor: pointer;
}
</style>

<template>
  <div>
    <b-card v-if="consent.date">
      <b-row class="consent-row">
        <b-col class="container">
          <h4>Date of signing:</h4>
        </b-col>
        <b-col class="container">
          <p>{{consent.date.split('T')[0]}}</p>
        </b-col>
      </b-row>
      <b-row class="consent-row">
        <b-col class="container">
          <h4>Consent Given:</h4>
        </b-col>
        <b-col class="container">
          <p v-if="consent.consent_given">Yes</p>
          <p v-else>No</p>
        </b-col>
      </b-row>
      <b-row class="consent-row" v-if="consent.signed_for_student">
        <b-col class="container">
          <h4>Signed for by:</h4>
        </b-col>
        <b-col class="container">
          <p>{{consent.signed_for_student}}</p>
        </b-col>
      </b-row>
      <b-row class="consent-row">
        <b-col class="container">
          <h4>Photo:</h4>
        </b-col>
        <b-col class="container">
          <img
            @click="fsGal_DisplayImage"
            max-height="150px"
            max-width="150px"
            :src="`data:image/png;base64,${consent.photo}`"
            ref="consent_img"
          />
        </b-col>
      </b-row>
    </b-card>

    <b-card v-else>
      <h3>No Consent Form Found</h3>
    </b-card>

    <div class="fs-gal-view" v-bind:style="{'background-image': 'url('+src+')'}" v-if="showImg">
      <img
        class="fs-gal-close"
        src="../../public/img/close.svg"
        title="Close Image"
        @click="closeImg()"
      />
    </div>
  </div>
</template>

  
<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "DataConsent",
  props: {
    singular: String,
    plural: String,
    type: String
  },
  data() {
    return {
      src: "",
      showImg: false
    };
  },
  methods: {
    ...mapActions({
      GET_DATA_CONSENT: "extras/GET_DATA_CONSENT"
    }),
    fsGal_DisplayImage: function(event) {
      this.showImg = true;
      if (event) console.log(event);
      const obj = event.target;
      //Set current image
      var img = obj.src;
      this.src = img;
    },
    closeImg() {
      this.showImg = false;
      this.src = "";
    }
  },
  computed: {
    consent: {
      get() {
        console.log("consent: ", this.$store.state.extras.dataConsents);
        return this.$store.state.extras.dataConsents;
      }
    }
  },
  created() {
    this.GET_DATA_CONSENT(this.type);
  }
};
</script>
